import { create } from 'zustand';
import {
  getBlockedCustomers,
  getPrepaidPinCode,
  getServiceablePincode,
  uploadBlockedCustomers,
  uploadPrepaidPinCode,
  uploadServiceablePinCode,
} from '../api';

export const useUploadPincode = create((set, get) => ({
  prepaidPincodeData: [],
  serciveablePincodeData: [],
  blockedCustomersData: [],
  fetchServiceablePincode: async () => {
    try {
      const response = await getServiceablePincode();
      set({ serciveablePincodeData: response.data });
    } catch (error) {
      console.error(error);
    }
  },
  fetchPrepaidPincode: async () => {
    try {
      const response = await getPrepaidPinCode();
      set({ prepaidPincodeData: response.data });
    } catch (error) {
      console.error(error);
    }
  },
  fetchBlockedCustomersData: async () => {
    try {
      set({ serviceableLoading: true, error: null });
      const response = await getBlockedCustomers();
      set({ blockedCustomersData: response?.data });
    } catch (error) {
      console.error(error);
    }
  },
  uploadPrepaidPincodesFile: async (
    fileData,
    setFileList,
    message,
    setUploading
  ) => {
    const { fetchPrepaidPincode } = get();
    try {
      await uploadPrepaidPinCode(fileData);
      await fetchPrepaidPincode();
      setFileList([]);
      message.success('upload successfully.');
    } catch (error) {
      console.log('error', error);
      message.error(`upload failed "${error.response.data.message}"`);
    } finally {
      setUploading(false);
    }
  },
  uploadServiceablePincodesFile: async (
    fileData,
    setFileList,
    message,
    setUploading
  ) => {
    const { fetchServiceablePincode } = get();
    try {
      await uploadServiceablePinCode(fileData);
      await fetchServiceablePincode();
      setFileList([]);
      message.success('upload successfully.');
    } catch (error) {
      message.error(`upload failed "${error.response.data.message}"`);
    } finally {
      setUploading(false);
    }
  },
  uploadblockedCustomers: async (
    fileData,
    setFileList,
    message,
    setUploading
  ) => {
    const { fetchBlockedCustomersData } = get();
    try {
      await uploadBlockedCustomers(fileData);
      await fetchBlockedCustomersData();
      setFileList([]);
      message.success('upload successfully.');
    } catch (error) {
      message.error(`upload failed "${error.response.data.message}"`);
    } finally {
      setUploading(false);
    }
  },
}));
